/** 表格字段 */
export const TableFields = {
    /** 周期 */
    time: 'name',

    /** 图片Url */
    imgUrl: 'url',

    /** 状态 */
    state: 'status'
};

/** 开启状态 */
export const State = {
    /** 开启 */
    start: '1',

    /** 关闭 */
    close: '0',

    /** 开启 */
    '0': '开启',

    /** 关闭 */
    '1': '关闭'

};
